import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CountryPickerComponent } from '@go-modules/components/country-picker/country-picker.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule
	],
	declarations: [
		CountryPickerComponent
	],
	exports: [
		CountryPickerComponent
	]
})
export class CountryPickerModule {}
